
import { postFormData } from './fetch';
import API from './api';

/**
 * 切换语言
 * @param  {string} lang 语言
 */
export function changeLanguage(lang: string) {
    const formData = new FormData();
    formData.append('option_type', '7');
    formData.append('option_value', lang);

    return postFormData(API.CHANGE_LANGUAGE.url, formData);
}
